import { Container } from "react-bootstrap"
import NewPostForm from "../../components/newPostForm/NewPostForm"

const NewPost = () => {

    return (

        <Container>
            <h1>HOla</h1>
            <NewPostForm />


        </Container>
    )
}

export default NewPost